import { Footer } from '@giffgaff/fe-design-system-ui'

import TamaguiScope from './TamaguiScope'

export default function BrandRefreshFooter() {
  return (
    <TamaguiScope styleId="fallback-footer-css">
      <footer>
        <Footer tag="div" />
      </footer>
    </TamaguiScope>
  )
}
